

export const getContentColor = (text: string): string | null => {
  const lower = text.toLowerCase();

  const map: { [key: string]: string } = {
    // Status / Alerts
    "error": "#ef4444", "bug": "#ef4444", "fail": "#ef4444", "stop": "#ef4444", "danger": "#ef4444", "hot": "#ef4444", "fire": "#ef4444", "red": "#ef4444",
    "warning": "#f59e0b", "caution": "#f59e0b", "slow": "#f59e0b", "wait": "#f59e0b", "orange": "#f97316", "gold": "#f59e0b",
    "success": "#22c55e", "pass": "#22c55e", "done": "#22c55e", "start": "#22c55e", "go": "#22c55e", "good": "#22c55e", "green": "#22c55e",
    "info": "#3b82f6", "note": "#3b82f6", "blue": "#3b82f6", "cold": "#3b82f6", "water": "#0ea5e9", "ice": "#bae6fd",

    // Tech
    "react": "#61dafb", "ts": "#3178c6", "typescript": "#3178c6", "js": "#f7df1e", "javascript": "#f7df1e",
    "css": "#d946ef", "html": "#e34f26", "python": "#3776ab", "node": "#8cc84b", "database": "#10b981", "db": "#10b981",
    "cloud": "#0ea5e9", "server": "#64748b", "api": "#8b5cf6", "ai": "#a855f7", "gpt": "#10b981", "gemini": "#4f46e5",

    // Concepts
    "design": "#ec4899", "art": "#ec4899", "ui": "#ec4899", "ux": "#f472b6",
    "money": "#10b981", "finance": "#10b981", "cost": "#ef4444", "profit": "#22c55e",
    "time": "#06b6d4", "plan": "#6366f1", "idea": "#eab308", "love": "#f43f5e",
    "people": "#f59e0b", "team": "#f59e0b", "user": "#f59e0b",
    
    // Nature
    "sky": "#38bdf8", "ocean": "#1e40af", "earth": "#15803d", "sun": "#facc15", "moon": "#94a3b8", "space": "#1e1b4b"
  };

  // 1. Direct match
  if (map[lower]) return map[lower];

  // 2. Keyword inclusion match (longest match wins to avoid partials like 'art' in 'start')
  const keys = Object.keys(map).sort((a, b) => b.length - a.length);
  for (const key of keys) {
    if (lower.includes(key)) {
      return map[key];
    }
  }

  return null;
};

export const getContrastColor = (hex: string | undefined | null): string => {
  if (!hex || typeof hex !== 'string') return '#000000';

  // Convert hex to RGB
  // Support shorthand #ABC
  // Defensive check for string methods before calling them
  const safeHex = String(hex);
  let color = safeHex.startsWith('#') ? safeHex.slice(1) : safeHex;
  
  if (color.length === 3) {
      color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
  }
  
  if (color.length !== 6) return '#000000';

  const r = parseInt(color.slice(0, 2), 16);
  const g = parseInt(color.slice(2, 4), 16);
  const b = parseInt(color.slice(4, 6), 16);
  
  if (isNaN(r) || isNaN(g) || isNaN(b)) return '#000000';

  // Calculate luminance (YIQ)
  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  
  // Return black or white based on luminance
  return (yiq >= 128) ? '#000000' : '#ffffff';
};
